import { Form, type FormItemProps, Checkbox as AntdCheckbox, type CheckboxProps as AntdCheckboxProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

interface CheckboxProps extends Omit<FormItemProps, 'children'>, AntdCheckboxProps, Ii18nLabel {
  name: string;
  readOnly?: boolean;
}

export const Checkbox = ({ name, label, i18nLabel, rules, disabled, readOnly, ...props }: CheckboxProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item {...props} name={name} label={fieldLabel} rules={rules} valuePropName="checked">
      <AntdCheckbox disabled={disabled || readOnly} />
    </Form.Item>
  );
};
